import React, { useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import defaultIcon from "../../../assets/images/deafult/default-small-image.png";
import ErrorMessage from "../../../components/ErrorMessage";

const ContactAddModal = ({ schema, onCreate }) => {
  const modalCloseIconButton = useRef(null);
  const [imagePreview, setImagePreview] = useState(defaultIcon);
  const [imageTag, setImageTag] = useState("Iocn");
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: zodResolver(schema),
  });

  const onSubmit = (data) => {
    const { descriptionEn, email, imageBase64 } = data;

    const formData = new FormData();
    formData.append("image", imageBase64);
    formData.append("email", email);
    formData.append("descriptionEn", descriptionEn);

    reset();
    modalCloseIconButton.current.click();
    onCreate(formData);
  };

  const handleCloseModal = () => {
    reset();
    setImagePreview(defaultIcon);
  };

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    setValue("imageBase64", file);

    setImageTag(file.name);
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <>
      <div className="pb-4">
        <div className="text-right">
          <button
            className="add-btn"
            type="button"
            data-toggle="modal"
            data-target="#staticBackdrop"
          >
            Add contact +
          </button>
        </div>
        <div
          className="modal fade"
          id="staticBackdrop"
          data-backdrop="static"
          data-keyboard="false"
          tabIndex="-1"
          aria-labelledby="staticBackdropLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="staticBackdropLabel">
                  Add Contact
                </h5>
                <button
                  ref={modalCloseIconButton}
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={handleCloseModal}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body p-0">
                <div className="custom-card mb-0">
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="mb-4">
                      <div className="left mb-2">
                        <div className="image-uploader">
                          <label className="icon-update-btn" htmlFor="uploader">
                            <i className="fa fa-pencil"></i>
                          </label>
                          <input
                            id="uploader"
                            className="d-none"
                            type="file"
                            accept="image/png, image/jpg, image/jpeg"
                            {...register("imageBase64", {
                              onChange: handleImageChange,
                            })}
                          />
                        </div>
                        <img src={imagePreview} alt={imageTag} />
                      </div>
                      {errors.imageBase64 && (
                        <ErrorMessage message={errors.imageBase64.message} />
                      )}
                    </div>
                    <div className="right">
                      <div className="mb-4">
                        <div className="form__div--textarea mb-0">
                          <textarea
                            className="form__textarea"
                            rows="4"
                            {...register("descriptionEn")}
                          />
                          <label htmlFor="" className="textarea-form__label">
                            Description
                          </label>
                        </div>
                        {errors.descriptionEn && (
                          <ErrorMessage
                            message={errors.descriptionEn.message}
                          />
                        )}
                      </div>
                      <div className="form__div-container">
                        <div className="form__div">
                          <input
                            type="email"
                            className="form__input"
                            {...register("email")}
                          />
                          <label htmlFor="" className="form__label">
                            Email
                          </label>
                        </div>
                        {errors.email && (
                          <ErrorMessage message={errors.email.message} />
                        )}
                      </div>
                      <div className="text-right">
                        <button type="submit" className="save-btn">
                          Submit
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactAddModal;
